<!-- Base.Checkbox.vue (client) -->
<template tag="클라이언트 체크박스 컴포넌트">
  <p class="check_row">
    <label>
      <input
        type="checkbox"
        :value="value"
        :checked="isChecked"
        @change="onChange"
        :disabled="disabled"
      />
      <span v-if="label || $slots.default">
        <slot>{{ label }}</slot>
      </span>
    </label>
  </p>
</template>
<script setup lang="ts">
import { computed } from "vue";

/* ------------------------------------------------------------
                          Model
   ------------------------------------------------------------ */
const model = defineModel<string | null>();

/* ------------------------------------------------------------
                          Props
   ------------------------------------------------------------ */
const props = defineProps({
  value: { type: String, default: "" },
  label: { type: String, default: "" },
  disabled: Boolean,
  checked: { type: Boolean, default: undefined },
});

/* ------------------------------------------------------------
                          Computed Properties
   ------------------------------------------------------------ */
/** 체크된 값 가져오기 */
const isChecked = computed(() => {
  if (props.checked !== undefined) {
    return props.checked;
  }
  if (!model.value) return false;
  return model.value.includes(props.value);
});

/* ------------------------------------------------------------
                          Methods
   ------------------------------------------------------------ */
/** 변경 이벤트 처리 */
const onChange = (event: Event) => {
  const target = event.target as HTMLInputElement;
  if (target.checked) {
    model.value = props.value;
  } else {
    model.value = null;
  }
};
</script>
